import defaultSettings from '@/utils/settings';

const { sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle } = defaultSettings;

const storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || '';
const state = {
  title: '',
  theme: storageSetting.theme || '#409EFF',
  sideTheme: storageSetting.sideTheme || sideTheme,
  showSettings: showSettings,
  topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
  tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
  fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
  sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
  dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle,
  language: window.localStorage.getItem('reaLinks-lang') || defaultSettings.language,
  langs: null,
  languageList: [],
};
const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  SET_LANG: (state, lang) => {
    state.language = lang;
  },
};

const actions = {
  // 修改布局设置
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data);
  },
  // 设置网页标题
  setTitle(_, title) {
    state.title = title;
  },
  setLang({ commit }, lang) {
    commit('SET_LANG', lang);
  },
  setLangs(_, langs) {
    state.langs = langs;
  },
  setLanguageList(_, langs) {
    state.languageList = langs;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
